import { BrandsEnum } from "../enums";
import { createTheme } from "@material-ui/core/styles";
import { polestar } from "./polestar";
import { volkswagen } from "./volkswagen";
import { audi } from "./audi";
import { kia } from "./kia";
import { bmw } from "./bmw";
import { volvia } from "./volvia";
import { nissan } from "./nissan";
import { renault } from "./renault";
import { porsche } from "./porsche";
import { skoda } from "./skoda";
import { mercedes } from "./mercedes";
import { ford } from "./ford";
import { rullaVidare } from "./rullavidare";
import { seat } from "./seat";
import { opel } from "./opel";
import { mini } from "./mini";
import { dacia } from "./dacia";
import { cupra } from "./cupra";
import { mg } from "./mg";
import { volviano } from "./volviano";
import { nissanno } from "./nissanno";

export type { default as Theme } from "./common/Theme";

// this is needed for storybook theme provider, and also for logic below
export const themes = [
  polestar,
  rullaVidare,
  volkswagen,
  audi,
  kia,
  cupra,
  bmw,
  volvia,
  nissan,
  renault,
  mg,
  porsche,
  skoda,
  mercedes,
  ford,
  seat,
  opel,
  mini,
  dacia,
  volviano,
  nissanno,
];

// mapping branded themes with brands enum (input param to switch specific brand)
export function getBrandedTheme(brand: BrandsEnum) {
  let theme = themes.find(x => x.brand === brand);

  if (!theme) {
    switch (brand.toLowerCase()) {
      case BrandsEnum.Volkswagentransportbilar:
        theme = volkswagen;
        break;
      case BrandsEnum.VolviaForetag:
        theme = volvia;
        break;
      case BrandsEnum.MG:
        theme = mg;
        break;
      case BrandsEnum.NissanNoMO:
        theme = nissanno;
        break;
      case BrandsEnum.IfRullaVidareMO:
        theme = rullaVidare;
        break;
      case BrandsEnum.BmwMO:
        theme = bmw;
        break;
      case BrandsEnum.PolestarMO:
        theme = polestar;
        break;
      case BrandsEnum.PolestarForetag:
        theme = polestar;
        break;
      case BrandsEnum.PolestarForetagMO:
        theme = polestar;
        break;

    }
  }

  if (theme) {
    return createTheme(theme);
  }

  throw new Error(`No matching theme found for brand '${brand}'!`);
}
